import { useEffect } from "react";

import "./landingpage.css";

import Navbar from "../../components/navbar/navbar";
import Footer from "../../components/footer/footer";
import Section1 from "../../components/section1/section1";
import Section2 from "../../components/section2/section2";
import Section3 from "../../components/section3/section3";
import Section4 from "../../components/section4/section4";
import Whatsapp from "../../components/whatsapp/whatsapp";
import SEO from "../../components/seo/SEO";

import { getLegalServiceSchema } from "../../utils/schemas";

function Landingpage() {
  useEffect(() => {
    const hash = window.location.hash;

    if (hash) {
      const element = document.querySelector(hash);

      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: "smooth" });
        }, 100);
      }
    }
  }, []);

  return (
    <div className="container-fluid p-0 landingpage">
      <SEO
        title="Antonio Saldanha Advocacia | Escritório de Advocacia em São Paulo"
        description="Antonio Saldanha Advocacia. Atuação jurídica moderna, ética e estratégica em Direito Trabalhista, Penal, Previdenciário, Cível e Empresarial. Atendimento nacional."
        canonical="https://antoniosaldanhaadvocacia.com.br/"
        schemaJson={getLegalServiceSchema()}
      />

      <Navbar />

      <main id="conteudo-principal">
        <Section1 />

        <section id="escritorio-resumo" aria-label="Apresentação do Escritório">
          <Section2 />
        </section>

        <section id="areas" aria-label="Áreas de Atuação">
          <Section3 />
        </section>

        <section id="contato" aria-label="Contato e Localização">
          <Section4 />
        </section>
      </main>

      <Footer />
      <Whatsapp />
    </div>
  );
}

export default Landingpage;
